import { render, staticRenderFns } from "./actlist.vue?vue&type=template&id=1f1344e6&scoped=true"
import script from "./actlist.vue?vue&type=script&lang=js"
export * from "./actlist.vue?vue&type=script&lang=js"
import style0 from "./actlist.vue?vue&type=style&index=0&id=1f1344e6&prod&scoped=true&lang=css"
import style1 from "./actlist.vue?vue&type=style&index=1&id=1f1344e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1344e6",
  null
  
)

export default component.exports